import React from "react";

export function SettingsSkeleton() {
  return (
    <div className="p-5">
      <div
        role="status"
        className="animate-pulse flex flex-col lg:flex-row justify-between items-start">
        <div className="w-full lg:w-1/3">
          <div className="h-4 bg-secondary opacity-10 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
          <div className="h-3 bg-secondary opacity-10 rounded-full dark:bg-gray-700 w-72 mb-2.5"></div>
        </div>
        <div className="w-full lg:w-2/3">
          {Array.from({ length: 2 }, (_, index) => (
            <div key={index} className="pb-4">
              <div className="h-3 bg-secondary opacity-10 rounded-full dark:bg-gray-700 w-48 mb-3"></div>
              <div className="h-5 bg-secondary opacity-10 rounded-full dark:bg-gray-700 w-full mb-2.5"></div>
            </div>
          ))}
        </div>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}
